// extracted by mini-css-extract-plugin
export const row = "about-module--row--1Uqt1";
export const left = "about-module--left--2plax";
export const profilepic = "about-module--profilepic--2FvvV";
export const right = "about-module--right--pLaWk";